import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import image1 from "../../../assets/updatedBannerImage/blogcard2.jpg";
import image2 from "../../../assets/updatedBannerImage/blogcard1.jpg";
import image3 from "../../../assets/donate1.jpg";
import image4 from "../../../assets/donate2.jpg";

const PhilanthropySection = () => {
    return (
        <Box sx={{ width: '100%', px: { xs: 2, sm: 3, md: 4 }, py: { xs: 3, md: 4 }, boxSizing: 'border-box' }}>

            {/* First Row */}
            <Grid container spacing={4} alignItems="center">
                {/* Left Image */}
                <Grid item xs={12} md={6}>
                    <Box
                        component="img"
                        src={image1}
                        alt="Kids studying mushrooms"
                        sx={{
                            width: '100%',
                            height: { xs: 200, md: 'auto' },
                            objectFit: 'cover',
                            borderRadius: 1,
                        }}
                    />
                </Grid>

                {/* Right Text */}
                <Grid item xs={12} md={6}>
                    <Box sx={{ px: { xs: 0, md: 4 } }}>
                        <Typography variant="h6" fontWeight={700} gutterBottom sx={{fontFamily: "Montserrat, sans-serif",}}>
                            Be a Philanthropic Partner
                        </Typography>
                        <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.6 ,fontFamily: "Montserrat, sans-serif",}}>
                            Join us as a philanthropic partner and bring your unique skills, resources and passion to help ATREE create positive change in our communities and the environment. Your support will enable us to pursue our mission and make a meaningful impact on the world.
                        </Typography>
                    </Box>
                </Grid>
            </Grid>

            {/* Second Row */}
            <Grid container spacing={4} alignItems="center" sx={{ mt: { xs: 3, md: 6 } }}>
                {/* Left Text */}
                <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
                    <Box sx={{ px: { xs: 0, md: 4 } }}>
                        <Typography variant="h6" fontWeight={700} gutterBottom sx={{fontFamily: "Montserrat, sans-serif",}}>
                            Consider a Strategic Endowment
                        </Typography>
                        <Typography variant="body1" color="text.secondary" sx={{ fontFamily: "Montserrat, sans-serif",lineHeight: 1.6 }}>
                            Create a lasting impact by contributing to our strategic endowment. Your investment offers ATREE the financial stability needed to pursue our mission for years to come, supporting our values and making a significant difference.
                        </Typography>
                    </Box>
                </Grid>

                {/* Right Image */}
                <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
                    <Box
                        component="img"
                        src={image2}
                        alt="Wild dogs resting"
                        sx={{
                            width: '100%',
                            height: { xs: 200, md: 'auto' },
                            objectFit: 'cover',
                            borderRadius: 1,
                        }}
                    />
                </Grid>
            </Grid>

            {/* Third Row */}
            <Grid container spacing={4} alignItems="center" sx={{ mt: { xs: 3, md: 6 } }}>
                {/* Left Image */}
                <Grid item xs={12} md={6}>
                    <Box
                        component="img"
                        src={image3}
                        alt="Image description"
                        sx={{
                            width: '100%',
                            height: { xs: 200, md: 'auto' },
                            objectFit: 'cover',
                            borderRadius: 1,
                        }}
                    />
                </Grid>

                {/* Right Text */}
                <Grid item xs={12} md={6}>
                    <Box sx={{ px: { xs: 0, md: 4 } }}>
                        <Typography variant="h6" fontWeight={700} gutterBottom sx={{fontFamily: "Montserrat, sans-serif",}}>
                            Be a Philanthropic Partner
                        </Typography>
                        <Typography variant="body1" color="text.secondary" sx={{fontFamily: "Montserrat, sans-serif", lineHeight: 1.6 }}>
                            Join us as a philanthropic partner and bring your unique skills, resources and passion to help ATREE create positive change in our communities and the environment. Your support will enable us to pursue our mission and make a meaningful impact on the world.
                        </Typography>
                    </Box>
                </Grid>
            </Grid>

            {/* Fourth Row */}
            <Grid container spacing={4} alignItems="center" sx={{ mt: { xs: 3, md: 6 } }}>
                {/* Left Text */}
                <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
                    <Box sx={{ px: { xs: 0, md: 4 } }}>
                        <Typography variant="h6" fontWeight={700} gutterBottom sx={{fontFamily: "Montserrat, sans-serif", }}>
                            Consider a Strategic Endowment
                        </Typography>
                        <Typography variant="body1" color="text.secondary" sx={{fontFamily: "Montserrat, sans-serif",  lineHeight: 1.6 }}>
                            Create a lasting impact by contributing to our strategic endowment. Your investment offers ATREE the financial stability needed to pursue our mission for years to come, supporting our values and making a significant difference.
                        </Typography>
                    </Box>
                </Grid>

                {/* Right Image */}
                <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
                    <Box
                        component="img"
                        src={image4}
                        alt="Image description"
                        sx={{
                            width: '100%',
                            height: { xs: 200, md: 'auto' },
                            objectFit: 'cover',
                            borderRadius: 1,
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default PhilanthropySection;
